import * as React from "react";
import { FC } from "react";

import { SessionKpi } from "@/features/training/model/Training/TrainingDrillSession";
import { DecimalEditCell } from "@/shared/data-grid";
import { useDataGridSingleClickEditing } from "@/shared/hooks";
import { Box } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useFormikContext } from "formik";

interface KpiInputsDataGridProps {
	kpiInputs: SessionKpi[];
	isDisabled: boolean;
}

export const KpiInputsDataGrid: FC<KpiInputsDataGridProps> = (props) => {
	const { setFieldValue, errors, setErrors } = useFormikContext<{
		KpiParameters: SessionKpi[];
	}>();
	const { cellModesModel, handleCellClick, handleCellModesModelChange } =
		useDataGridSingleClickEditing();

	const processRowUpdate = async (row: SessionKpi) => {
		const updatedRowIndex = props.kpiInputs.findIndex((x) => x.Id === row.Id);

		const updatedValues = [...props.kpiInputs];
		updatedValues[updatedRowIndex].Value = row.Value;

		const newErrors = { ...errors };
		delete newErrors.KpiParameters;
		setErrors(newErrors);

		await setFieldValue("KpiParameters", updatedValues);

		return row;
	};

	const columns: GridColDef<SessionKpi>[] = [
		{
			field: "Value",
			headerName: "Value",
			type: "number",
			editable: !props.isDisabled,
			renderEditCell: (params) => <DecimalEditCell {...params} />,
			align: "left",
			headerAlign: "left",
		},
		{
			field: "Name",
			headerName: "Name",
			align: "left",
			headerAlign: "left",
			flex: 1,
		},
		{
			field: "MaxValue",
			headerName: "Max Value",
			type: "number",
			align: "right",
		},
	];

	return (
		<Box sx={{ width: "100%" }}>
			<DataGrid<SessionKpi>
				columns={columns}
				rows={props.kpiInputs}
				getRowId={(row) => row.Id}
				processRowUpdate={(updatedRow) => processRowUpdate(updatedRow)}
				cellModesModel={cellModesModel}
				onCellModesModelChange={handleCellModesModelChange}
				onCellClick={(params, event) => {
					setErrors({ ...errors, KpiParameters: undefined });
					handleCellClick(params, event);
				}}
				getRowSpacing={() => ({ top: 5 })}
				disableColumnMenu
				hideFooter
				sx={{
					border: "none",
					minHeight: 120,
					"& .MuiDataGrid-cell": {
						borderColor: "divider",
					},
					"& .MuiDataGrid-columnHeaders": {
						borderColor: "divider",
					},
				}}
			/>
		</Box>
	);
};
